var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat"},[_c('div',{staticClass:"chat-title"},[_vm._v("聊天")]),_vm._v(" "),_c('chat-message',{staticClass:"chat-message"}),_vm._v(" "),_c('chat-input',{staticClass:"chat-input"}),_vm._v(" "),_c('welcome-vue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }